import { Radio, RadioGroup } from '@headlessui/react';

export type RendererView = '2d' | '3d';

interface ViewToggleProps {
  value: RendererView;
  onChange: (v: RendererView) => void;
}

const OPTIONS: Array<{ value: RendererView; label: string }> = [
  { value: '3d', label: '3D' },
  { value: '2d', label: 'Layout' },
];

export function ViewToggle({ value, onChange }: ViewToggleProps) {
  return (
    <RadioGroup
      value={value}
      onChange={onChange}
      aria-label="Renderer view"
      className="inline-flex p-0.5 bg-hilevel-light rounded border border-hilevel-border"
    >
      {OPTIONS.map((opt) => (
        <Radio
          key={opt.value}
          value={opt.value}
          className={({ checked }) =>
            `cursor-pointer px-3 py-1.5 text-sm rounded transition-colors ${
              checked
                ? 'bg-white shadow-sm text-hilevel-slate font-semibold'
                : 'text-hilevel-gray hover:text-hilevel-slate'
            }`
          }
        >
          {opt.label}
        </Radio>
      ))}
    </RadioGroup>
  );
}
